var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedalj(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "band-bg",
    d: "M66.68,37.33L90.63,2.33h-27.03s-21.21,30.41-21.21,30.41c0,0,10.69-2.26,24.29,4.59Z",
    fill: "#e6e7e8",
    stroke: "#2b3990",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "band-fg",
    d: "M33.32,37.33L9.37,2.33h27.03l21.21,30.41s-10.69-2.26-24.29,4.59Z",
    fill: "#fff",
    stroke: "#2b3990",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "medal-bg",
    cx: 50.2,
    cy: 64.23,
    r: 33,
    fill: "#fbb040",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "medal-plate",
    cx: 50.2,
    cy: 64.23,
    r: 27.5,
    fill: "#f0e936",
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "medal-plate-2",
    "data-name": "medal-plate",
    cx: 50.2,
    cy: 64.23,
    r: 14,
    fill: "#fff",
    stroke: "#bcbec0",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalj);
export default __webpack_public_path__ + "static/media/medalj.c3e722217fa79e86007a63bb68156845.svg";
export { ForwardRef as ReactComponent };